import React from "react";
import { useTheme } from "../theme/ThemeProvider";

export default function ThemeSwitch() {
  const { theme, setTheme, cycleTheme } = useTheme();

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <select
        aria-label="Select theme"
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
        style={{
          padding: "6px 10px",
          border: "1px solid var(--border)",
          background: "var(--card)",
          color: "var(--text)",
          borderRadius: 6,
        }}
      >
        <option value="light">🌞 Light</option>
        <option value="dark">🌙 Dark</option>
        <option value="gta">🎮 GTA</option>
      </select>

      <button
        type="button"
        onClick={cycleTheme}
        style={{
          background: "var(--bg-elev)",
          color: "var(--text)",
          border: "1px solid var(--border)",
          padding: "6px 10px",
          borderRadius: 6,
          cursor: "pointer",
        }}
        title="Cycle theme"
      >
        ⟳
      </button>
    </div>
  );
}
